<template>
  <div>
    <div class="d-flex align-items-center flex-wrap justify-content-end" v-if="scheduled">
      <b-button
        variant="link"
        class="no-wrap mt-2"
        size="sm"
        @click="$emit('onCta', 'instructions')"
      >
        {{ trans("courses.esercizi.see_instructions") }}</b-button
      >
      <b-button
        variant="secondary"
        class="no-wrap ml-2 mt-2"
        size="sm"
        @click="$emit('onCta', 'reflections')"
      >
        {{ trans("courses.new_dashboard.have_to_complete_mission") }}</b-button
      >
    </div>
    <b-button
      variant="secondary"
      class="align-self-end px-3"
      size="sm"
      @click="$emit('onCta', 'instructions')"
      v-else
    >
      {{ trans("courses.new_dashboard.start_now") }}</b-button
    >
  </div>
</template>

<script>
export default {
  name: "MissionCardContent",
  props: {
    scheduled: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.complete-mission {
  white-space: nowrap;
}
</style>
